import axios from "axios";
import { TTP_HOME_URL, TTP_DASHBOARD_URL, URL_HASH_KEY } from "Config";
import _ from "i18n";
import { NotificationManager } from "react-notifications";
import { EditorState, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import React from "react";
import CryptoJS from "crypto-js";

// TODO review this
export function isServiceActivated(service, resources, activatedPrefix = true) {
  for (let resource of resources) {
    if (
      false === activatedPrefix &&
      undefined !== resource.service &&
      1 === resource.service * 1
    ) {
      return true;
    }

    if (
      true === activatedPrefix &&
      undefined !== resource[`${service}Activated`] &&
      1 === resource[`${service}Activated`] * 1
    ) {
      return true;
    }
  }
  return false;
}

export const getDefaultLanguage = () => {
  const lng = navigator.language || navigator.userLanguage;
  return ["fr", "en", "nl"].includes(lng) ? lng : "en";
};

// TODO review this
const MyError = { response: { status: 700 } };

export function throwCatchedError(thrown) {
  if (axios.isCancel(thrown)) {
    throw MyError;
  } else {
    throw thrown;
  }
}

export const randomIntBetween = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const redirectToHome = (returnTo = "") => {
  const goto = encodeURI(TTP_DASHBOARD_URL + "/" + returnTo);
  window.location.assign(`${TTP_HOME_URL}?goto=${goto}`);
};

export function sortTags(tags, lng) {
  let sortedTags = tags;

  switch (lng) {
    case "en":
      sortedTags = tags.sort(function(a, b) {
        return a.nameEn === b.nameEn ? 0 : +(a.nameEn > b.nameEn) || -1;
      });
      break;
    case "fr":
      sortedTags = tags.sort(function(a, b) {
        return a.nameFr === b.nameFr ? 0 : +(a.nameFr > b.nameFr) || -1;
      });
      break;
    case "nl":
      sortedTags = tags.sort(function(a, b) {
        return a.nameNl === b.nameNl ? 0 : +(a.nameNl > b.nameNl) || -1;
      });
      break;
    default:
  }

  return sortedTags;
}

export const getTagNameAttr = lng => {
  return `name${lng.charAt(0).toUpperCase() + lng.slice(1)}`;
};

export const getURLEmbeddedParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return {
    embedded: searchParams.get("embedded") || "false"
  };
};

export const getURLParams = location => {
  const searchParams = new URLSearchParams(location.search);
  let hashParams = searchParams.get("params") || null;
  let tab = {
    queryToken: "",
    uaWithoutHeader: false,
    userId: null,
    organization_id: null,
    portal: null
  };
  if (hashParams) {
    hashParams = decryptWithAES(decodeURIComponent(hashParams));
    const tabQueryParams = hashParams.split(",");
    tabQueryParams.forEach(item => {
      const tmp = item.split("=");
      if (tmp.length > 0) {
        if (tmp[0] === "token") {
          tab.queryToken = tmp[1];
        } else if (tmp[0] === "userId") {
          tab.userId = tmp[1];
        } else if (tmp[0] === "without_header") {
          tab.uaWithoutHeader = true;
        } else if (tmp[0] === "organization_id") {
          tab.organization_id = tmp[1];
        } else if (tmp[0] === "portal") {
          tab.portal = tmp[1];
        }
      }
    });
  }
  return tab;
};

export const getURLWithoutHeaderParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return {
    withoutHeader: searchParams.has("without_header")
  };
};

export const getAccessKeyParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("access_key") || null;
};

export const getOrganizationIdParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("organization_id") || null;
};

export const getEmbedWidthParam = location => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get("embed_width") || null;
};

export function onSuccess(res, message = null) {
  if (!message) {
    message = { body: "operationCompleted", title: "successfulAction" };
  }
  if (res.value instanceof Error) {
    NotificationManager.error(_("incompleteOperation"), _("error"));
  } else {
    NotificationManager.success(_(message.body), _(message.title));
  }
}

export function onError(message) {
  if (!message) {
    message = "errorOccured";
  }
  NotificationManager.error(_(message), _("error"));
}

export const dateFormat = (dateToFormat, lng, withoutTime = false) => {
  dateToFormat = dateToFormat.includes("/")
    ? dateToFormat.replace("/", "-")
    : dateToFormat;

  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  var options = {
    year: "numeric",
    month: "long",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: timeZone,
    hour12: false
  };
  const date = new Date(dateToFormat);
  const dtf = new Intl.DateTimeFormat(lng, options);
  const [
    { value: mo },
    ,
    { value: da },
    ,
    { value: ye },
    ,
    { value: ho },
    ,
    { value: mi },
    ,
    { value: se }
  ] = dtf.formatToParts(date);

  if (withoutTime) {
    return `${mo} ${da} ${ye}`;
  }

  return `${mo} ${da} ${ye}, ${ho}:${mi}:${se}`;
};

export const createEditorState = html => {
  if (!html) {
    return EditorState.createEmpty();
  }
  const blocksFromHTML = htmlToDraft(html);
  const editorState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );

  return EditorState.createWithContent(editorState);
};

export const folderRolesManager = roleCollaborator => {
  return (
    <div>
      {roleCollaborator &&
        roleCollaborator.SUP && (
          <div>
            <span>SUP</span>
            {" : "}
            <span>{roleCollaborator.SUP.name}</span>
          </div>
        )}
      {roleCollaborator &&
        roleCollaborator.GD && (
          <div>
            <span>GD</span>

            {" : "}
            <span>{roleCollaborator.GD.name}</span>
          </div>
        )}
      {roleCollaborator &&
        roleCollaborator.ScanOP && (
          <div>
            <span>ScanOP</span>
            {" : "}
            <span>{roleCollaborator.ScanOP.name}</span>
          </div>
        )}
      {roleCollaborator &&
        roleCollaborator.SE && (
          <div>
            <span>SE</span>
            {" : "}
            <span>{roleCollaborator.SE.name}</span>
          </div>
        )}
      {roleCollaborator &&
        roleCollaborator.GE && (
          <div>
            <span>GE</span>
            {" : "}
            <span>{roleCollaborator.GE.name}</span>
          </div>
        )}
    </div>
  );
};

export const folderRolesCollaborator = (roleCollaborator, userId) => {
  return (
    <div>
      {roleCollaborator &&
        roleCollaborator.SUP &&
        (userId && userId.toString() === roleCollaborator.SUP.apiId ? (
          <div>
            <div>
              <span>SUP</span>
            </div>
          </div>
        ) : (
          ""
        ))}
      {roleCollaborator &&
        roleCollaborator.GD &&
        (userId && userId.toString() === roleCollaborator.GD.apiId ? (
          <div>
            <div>
              <span>GD</span>
            </div>
          </div>
        ) : (
          ""
        ))}
      {roleCollaborator &&
        roleCollaborator.ScanOP &&
        (userId && userId.toString() === roleCollaborator.ScanOP.apiId ? (
          <div>
            <div>
              <span>ScanOP</span>
            </div>
          </div>
        ) : (
          ""
        ))}
      {roleCollaborator &&
        roleCollaborator.SE &&
        (userId && userId.toString() === roleCollaborator.SE.apiId ? (
          <div>
            <div>
              <span>SE</span>
            </div>
          </div>
        ) : (
          ""
        ))}
      {roleCollaborator &&
        roleCollaborator.GE &&
        (userId && userId.toString() === roleCollaborator.GE.apiId ? (
          <div>
            <div>
              <span>GE</span>
            </div>
          </div>
        ) : (
          ""
        ))}
    </div>
  );
};

export const decryptWithAES = ciphertext => {
  var encryptMethod = "AES-256-CBC";
  var aesNumber = encryptMethod.match(/\d+/)[0];
  var encryptMethodLength = parseInt(aesNumber);

  var json = JSON.parse(
    CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(ciphertext))
  );

  var salt = CryptoJS.enc.Hex.parse(json.salt);
  var iv = CryptoJS.enc.Hex.parse(json.iv);

  var encrypted = json.ciphertext; // no need to base64 decode.

  var iterations = parseInt(json.iterations);
  if (iterations <= 0) {
    iterations = 999;
  }
  var encryptMethodLength = encryptMethodLength / 4; // example: AES number is 256 / 4 = 64
  var hashKey = CryptoJS.PBKDF2(URL_HASH_KEY, salt, {
    hasher: CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations: iterations
  });

  var decrypted = CryptoJS.AES.decrypt(encrypted, hashKey, {
    mode: CryptoJS.mode.CBC,
    iv: iv
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const getLabelsByLng = (labels, lng) => {
  if (labels && labels[lng]) {
    return labels[lng];
  }
  if (labels) {
    if (lng === "fr") {
      return labels["en"] ? labels["en"] : labels["nl"];
    }
    if (lng === "en") {
      return labels["fr"] ? labels["fr"] : labels["nl"];
    }
    if (lng === "nl") {
      return labels["en"] ? labels["en"] : labels["fr"];
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/common.js